/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TemplatizeEnvelopeRequest { 
    envelopeTemplateId?: string | null;
    envelopeTemplateName?: string | null;
    envelopeId?: string | null;
    envelopeName?: string | null;
    envelopeDescription?: string | null;
    envelopeEmailBlurb?: string | null;
    envelopeEmailSubject?: string | null;
    accountId?: string | null;
    externalEnvelopeId?: string | null;
    certificateId?: string | null;
    envelopeStatusId?: string | null;
    isActive?: boolean | null;
    timeStamp?: string | null;
    readonly spolloNullIsValue_EnvelopeTemplateName?: boolean;
    readonly spolloNullIsValue_EnvelopeId?: boolean;
    readonly spolloNullIsValue_EnvelopeName?: boolean;
    readonly spolloNullIsValue_EnvelopeDescription?: boolean;
    readonly spolloNullIsValue_EnvelopeEmailBlurb?: boolean;
    readonly spolloNullIsValue_EnvelopeEmailSubject?: boolean;
    readonly spolloNullIsValue_AccountId?: boolean;
    readonly spolloNullIsValue_ExternalEnvelopeId?: boolean;
    readonly spolloNullIsValue_CertificateId?: boolean;
    readonly spolloNullIsValue_EnvelopeStatusId?: boolean;
    templatizeDependencies?: boolean;
}

